
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M36.628 12.985c-2.69 0-13.17 8.48-13.17 24.76 0 7.27 5.9 13.17 13.17 13.17s13.17-5.9 13.17-13.17c0-16.28-10.48-24.76-13.17-24.76z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M43.708 37.745c0-16.28-5.63-24.76-7.07-24.76-.99 0-3.93 3.96-5.69 11.66m-1.09 16.93c.88 5.41 3.58 9.34 6.77 9.34 3.35 0 6.16-4.34 6.89-10.17m-13.41-11.51c-.3 2.17-.49 4.56-.54 7.16m7.06-23.41v37.93m-5.49-34.23c-4.6-5.71-9.97-8-11.62-7.65-2.63.56-11.12 11.04-7.73 26.96 1.46 6.85 7.99 11.31 14.82 10.29"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M28.118 20.635c-3.47-8.12-7.58-11.81-8.6-11.6-.96.21-3.02 4.69-3.14 12.59m2.46 16.79c1.81 4.64 4.83 7.79 7.71 7.82m-10.03-19.94c.16 2.19.47 4.56.96 7.11m2.04-24.37l4.62 21.75"}})])
          )
        }
      }
    